var _g, _g2, _g3, _g4, _g5, _g6, _ellipse, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDecorationGlobe = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4401,
    height: 3010,
    viewBox: "0 0 4401 3010",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_i_101_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1877.71 1029.86C1830.24 1150.68 1703.11 1227.1 1535.77 1252.88C1368.44 1278.66 1161.01 1253.79 953.154 1172.13C745.294 1090.46 576.407 967.483 471.378 834.698C366.34 701.901 325.23 559.383 372.698 438.563C420.167 317.742 547.295 241.322 714.636 215.539C881.963 189.759 1089.39 214.631 1297.25 296.296C1505.11 377.961 1674 500.938 1779.03 633.723C1884.07 766.52 1925.18 909.038 1877.71 1029.86Z",
    stroke: "url(#paint0_linear_101_212)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_i_101_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1883.91 1051.07C1836.44 1171.89 1709.32 1248.31 1541.98 1274.09C1374.65 1299.87 1167.22 1275 959.357 1193.34C751.498 1111.67 582.611 988.693 477.582 855.908C372.544 723.112 331.433 580.594 378.902 459.773C426.37 338.953 553.498 262.533 720.839 236.75C888.167 210.969 1095.6 235.842 1303.46 317.507C1511.32 399.171 1680.2 522.149 1785.23 654.934C1890.27 787.73 1931.38 930.248 1883.91 1051.07Z",
    stroke: "url(#paint1_linear_101_212)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_101_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 1860.97C75.0001 1259.25 1026.62 771.467 2200.5 771.467C3374.38 771.467 4326 1259.25 4326 1860.97C4326 2462.68 3374.38 2950.47 2200.5 2950.47C1026.62 2950.47 75 2462.68 75.0001 1860.97ZM4249.8 1860.97C4249.8 1280.83 3332.3 810.528 2200.5 810.527C1068.71 810.527 151.204 1280.82 151.204 1860.97C151.204 2441.11 1068.7 2911.41 2200.5 2911.41C3332.3 2911.41 4249.8 2441.11 4249.8 1860.97Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_101_212)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2180.73,
    cy: 1285.73,
    rx: 684.963,
    ry: 659.006,
    transform: "rotate(-42.6057 2180.73 1285.73)",
    fill: "#A908E2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_f_101_212)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1624.73,
    cy: 1363.73,
    rx: 684.963,
    ry: 659.006,
    transform: "rotate(-42.6057 1624.73 1363.73)",
    fill: "#359FF4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter5_f_101_212)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2842.73,
    cy: 1384.73,
    rx: 684.963,
    ry: 659.006,
    transform: "rotate(-42.6057 2842.73 1384.73)",
    fill: "#359FF4"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2200.5,
    cy: 1873.97,
    rx: 2125.5,
    ry: 1089.5,
    transform: "rotate(-180 2200.5 1873.97)",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_101_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 1844.97C75.0001 1243.25 1026.62 755.467 2200.5 755.467C3374.38 755.467 4326 1243.25 4326 1844.97C4326 2446.68 3374.38 2934.47 2200.5 2934.47C1026.62 2934.47 75 2446.68 75.0001 1844.97ZM4249.8 1844.97C4249.8 1264.83 3332.3 794.528 2200.5 794.527C1068.71 794.527 151.204 1264.82 151.204 1844.97C151.204 2425.11 1068.7 2895.41 2200.5 2895.41C3332.3 2895.41 4249.8 2425.11 4249.8 1844.97Z",
    fill: "#61B9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_101_212",
    x: 352.616,
    y: 205.297,
    width: 1545.18,
    height: 1062.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_101_212"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_101_212",
    x: 358.82,
    y: 226.508,
    width: 1545.18,
    height: 1062.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_101_212"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_101_212",
    x: 63.0001,
    y: 759.467,
    width: 4275,
    height: 2203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_101_212"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_101_212",
    x: 1282.53,
    y: 389.707,
    width: 1796.4,
    height: 1792.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.5,
    result: "effect1_foregroundBlur_101_212"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_101_212",
    x: 726.533,
    y: 467.707,
    width: 1796.4,
    height: 1792.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.5,
    result: "effect1_foregroundBlur_101_212"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_101_212",
    x: 1944.53,
    y: 488.707,
    width: 1796.4,
    height: 1792.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.5,
    result: "effect1_foregroundBlur_101_212"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_101_212",
    x: 0.00012207,
    y: 680.467,
    width: 4401,
    height: 2329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.5,
    result: "effect1_foregroundBlur_101_212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_212",
    x1: 1297.44,
    y1: 295.831,
    x2: 952.971,
    y2: 1172.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.229885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#8294B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_212",
    x1: 1303.64,
    y1: 317.041,
    x2: 959.175,
    y2: 1193.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.229885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#8294B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDecorationGlobe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/decoration-globe.b443e84faaa512272cdf63a5e3c2101f.svg";